<template>
  <iframe
    v-if="storeFeatureLoadable"
    :src="`https://player.vimeo.com/video/${videoId}?dnt=1`"
    frameborder="0"
    allowfullscreen
    webkitallowfullscreen
    mozallowfullscreen
  ></iframe>
</template>
<script>
import featureMixin from "../mixins/featureMixin";

export default {
  name: "VimeoIframe",
  mixins: [featureMixin],
  props: {
    videoId: {
      type: String,
      required: true,
    },
  },
};
</script>
